import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';

export const ProductPriceCaloriesContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.productPriceCaloriesContainer, style]} />
);

const styles = StyleSheet.create({
  productPriceCaloriesContainer: {
    alignItems: 'center',
    flexDirection: 'column',
    gap: 8,
    marginBottom: 12,
    marginTop: 0,
    width: '100%',
  },
});
